import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0" data-mp="2wjqgl4pbe0ll">
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed font-[800]" data-id="element-1" data-mp="28tw4wqgqei2x">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-surface font-sans text-brand-text selection:bg-brand-purple/25 selection:text-brand-purpleDark" data-id="element-2" data-mp="3ihv1odb3qjic">
      <div className="pointer-events-none fixed inset-0 -z-10 reiki-pattern opacity-[0.025]" aria-hidden="true" data-id="element-3" data-mp="3rbr9so7flver" />
      <UrgencyBanner data-id="element-4" data-mp="6801qozk67w" />
      <Hero data-id="element-5" data-mp="5gez9t0lqvv" />
      <PackContents data-id="element-6" data-mp="56m9egl55mh" />
      <InitialTestimonials data-id="element-7" data-mp="7sxbo2oq39g" />
      <PainPoints data-id="element-8" data-mp="2zlli5ahfl0qy" />
      <MethodOverview data-id="element-9" data-mp="2zm4vedw4z0yn" />
      <MoreTestimonials data-id="element-10" data-mp="2zmwguvw0rib7" />
      <Guarantee data-id="element-11" data-mp="33mou3lwcycmw" />
      <FAQ data-id="element-12" data-mp="33m5b01uz1i7a" />
      <CostComparison data-id="element-13" data-mp="33lwzoeehyky7" />
      <TransitionPhrase data-id="element-14" data-mp="33n6zp94wu37h" />
      <EmotionalClose data-id="element-15" data-mp="33ork45xig5rm" />
      <Footer data-id="element-16" data-mp="38m1gy6n8bjph" />
      <FloatingNotification data-id="element-17" data-mp="38l8f9k34nke7" />
    </div>;
}